import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import MotionDiv from "../motionDiv";
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';

function VideoBlock() {
    const [isOpen, setOpen] = useState(false);

    return (
        <section id="video" className="video-section layout-pt-60 layout-pb-60 js-tab-menu-content">
            <div className="auto-container">
                <Row>
                    <Col lg={12}>
                        <MotionDiv classes="col-12" variant={'fade'}>
                            <div className="sec-title">
                                <h2>
                                    Groupe Talents Handicap<br/>
                                    Un acteur engagé pour <span>l’égalité des chances</span>
                                </h2>
                                <div className="text">
                                    Nous mettons à votre <span>service notre expertise emploi et handicap</span>,
                                    <span>notre savoir-faire digital</span> et <span>notre capacité d’innovation</span>,
                                    avec un engagement fort et sincère, visant un impact durable.
                                </div>
                            </div>
                        </MotionDiv>
                    </Col>
                </Row>
                <MotionDiv delay={0.3} variant={'zoomIn'} duration={0.7}>
                    <Row className={'video-cta'}>

                        <Col lg={6} className={'video-cta-text'}>
                            <p>
                                <strong>“</strong>
                                <i>
                                    Notre raison d’être est double :
                                    <br/>
                                    <br/>
                                    - Accompagner les talents en situation de handicap vers un emploi qui
                                    <br/>
                                    leur correspond (compétences, aptitudes, projet de vie…)
                                    <br/>
                                    <br/>
                                    - Accompagner les employeurs engagés vers une performance durable et responsable
                                    qui tient compte des enjeux actuels et futurs du monde du travail :
                                    attractivité et rétention des talents, innovation, RSE, DEI (Diversité Équité Inclusion),
                                    accessibilité, QVCT (Qualité de vie et des conditions de travail), santé au travail,
                                    prévention des risques, développement des compétences (hard et soft skills)
                                    pour s’adapter aux évolutions des métiers et des technologies,
                                    faciliter les évolutions de carrière et les reconversions…
                                    <br/>
                                    <br/>
                                    Notre raison d’être est d’être à votre service.
                                </i>
                                <strong>”</strong>
                            </p>
                            <p>
                                Redwane Bennani
                                Fondateur et Président Groupe Talents Handicap
                            </p>
                        </Col>
                        <Col lg={6} className={'video-cta-picture'}>
                            <div className={'video-cta-picture-link'} aria-label="Video"
                               onClick={(e) => {
                                   e.preventDefault();
                                   setOpen(true);
                               }}>
                                <img src="/images/homepage/video.webp" alt="Video de Présentaiton"
                                     className="Video Groupe Talent Handicap"/>
                                <i className="flaticon-play-button default-blue"></i>
                            </div>
                        </Col>
                    </Row>
                </MotionDiv>
            </div>

            <ModalVideo
                channel="youtube"
                autoplay
                isOpen={isOpen}
                videoId="Vbp5MTIp7so"
                onClose={() => setOpen(false)}
            />

        </section>
    )
}

export default VideoBlock;
